import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
import qs from 'querystringify'
import { Toast } from 'vant'
Vue.use(Toast)

const whiteList = ['/api/images', '/api/attach/create', '/api/file/get-upload-id']
// 取消重复请求
let pending = []
let cancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) {
      pending[p].f()
      pending.splice(p, 1)
    }
  }
}

let cutReq = (config) => {
  const url = config.url.startsWith('http') ? config.url : config.url
  for (let p in pending) {
    if (pending[p].u === url + '&' + config.method) {
      return true
    }
  }
}

// create an axios instance
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const { method, data, contentType } = config
    // 请求包含undefined 直接return
    if (config.url.includes(undefined)) {
      console.log('参数错误')
      return false
    }
    // console.log(config)
    let flag = cutReq(config)
    if (flag === true) return null
    config.cancelToken = new cancelToken((c) => {
      const url = config.url.startsWith('http') ? config.url : config.url
      // 如果是白名单接口 不存入pending
      for (let i = 0; i < whiteList.length; i++) {
        // console.log('url', url, whiteList[i].indexOf(url) != -1)
        if (url.indexOf(whiteList[i]) != -1) {
          // console.log('存在')
          return
        }
      }
      pending.push({ u: url + '&' + config.method, f: c })
    })
    // parse data
    if (contentType === 'json') {
      config.headers['Content-Type'] = 'application/json'
    } else if (method !== 'get' && _.isObject(data)) {
      if (typeof config.headers['Content-Type'] === 'undefined') {
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        if (config.url.indexOf('/api/images') < 0 || config.url.indexOf('/api/videos') < 0) {
          config.data = qs.stringify(data)
        }
      }
    }
    if (sessionStorage.getItem('iform_wap_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('iform_wap_auth_token')
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log('请求错误：', error) // for debug
    pending = []
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    /* eslint-disable */ 
    // debugger
    removePending(response.config)
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 0) {
      // 如果表单未开始或者结束 501授权code失效
      if (res.code === 20051 || res.code === 20052 || res.code === 20053 || res.code == 200 || res.code == 501) {
        // to re-login
        return res
      } else {
        Toast(res.message)
        return Promise.reject(new Error(res.message || 'Error'))
      }
    } else {
      return res
    }
  },
  (error) => {
    console.log('响应错误：' + error)
    pending = []
    return Promise.reject(error)
  }
)
Vue.$request = service
export default service
